import type { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TGetCompanyDocumentPdfParams } from "./getCompanyDocumentPdf.schema";

export const getCompanyDocumentPdf =
  (axios: IAxiosInstance) => async (params: TGetCompanyDocumentPdfParams) => {
    // /view/form.pdf validates accessToken in-handler; /form.pdf requires session auth (shareable links fail).
    const response = await axios.noRetry.get<Blob>(
      `/pdf/${params.document_key}/${params.companyID}/view/form.pdf?accessToken=${params.accessToken}`,
      {
        responseType: "blob",
        headers: { Authorization: `Bearer ${params.accessToken}` },
      }
    );

    if (!response.data) {
      throw new Error("Failed to get company document PDF");
    }

    return response.data;
  };
